module.exports = __webpack_public_path__ + "d7c639084f684d66a1bc66855d193ed8.svg";


//////////////////
// WEBPACK FOOTER
// ./theme/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 88
// module chunks = 0